import React, {useState, useEffect} from 'react';
import QRScanner from './camera/Scanner';
import axios from "axios";
import {t, Locale} from './i18n';

interface ScanResponse {
    isValid: boolean;
    userId: string;
    action: string;
    first_photo_temporary_url?: string;
    actionable_type: string;
    id: string;
}

interface Property {
    id: string;
    latitude: number;
    longitude: number;
    full_address: string;
    street_address: string;
    city: string;
    state?: string;
    postcode: string;
    country: string;
    created_at: string;
    updated_at?: string;
}

interface Person {
    id: string;
    first_name: string;
    last_name: string;
    email?: string;
    is_staff_member?: boolean;
    phone?: string
}

function beep() {
    let snd = new Audio("data:audio/wav;base64,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");
    snd.play();
}

function App() {
    const [qrResult, setQrResult] = useState<string | null>(null);
    const [actionable, setActionable] = useState<ScanResponse | null>(null);
    const [property, setProperty] = useState<Property | null>(null);
    const [selectedAction, setSelectedAction] = useState<string>('choose');
    const [additionalInfo, setAdditionalInfo] = useState<string>('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isQrValid, setIsQrValid] = useState(false);
    const [showBanner, setShowBanner] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [currentUser, setCurrentUser] = useState<any>(null);
    const [locale, setLocale] = useState<Locale>('en');
    const [errorMessage, setErrorMessage] = useState<string | null | undefined>(null);
    const [successMessage, setSuccessMessage] = useState<string | null | undefined>(null);
    const [isScannerStarted, setIsScannerStarted] = useState(false);
    const [people, setPeople] = useState<Person[]>([]);
    const [selectedPersonId, setSelectedPersonId] = useState<string>('');
    const [isCreatingPerson, setIsCreatingPerson] = useState(false);
    const [newPerson, setNewPerson] = useState({
        first_name: '',
        last_name: '',
        email: '',
        is_staff_member: false,
        phone: ''
    });
    const [isStandalone, setIsStandalone] = useState(false);

    const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

    useEffect(() => {
        let oauthHandled = false;

        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const accessTokenParam = params.get('access_token');
        const stateParam = params.get('state');
        const errorParam = params.get('error');
        const savedState = sessionStorage.getItem('oauthState');

        if (errorParam) {
            setErrorMessage(params.get('error_description') || errorParam);
            sessionStorage.removeItem('oauthState');
            window.history.replaceState({}, document.title, window.location.pathname);
        } else if (accessTokenParam) {
            if (stateParam && savedState && stateParam !== savedState) {
                setErrorMessage(t(locale, 'Invalid OAuth state. Please try again.'));
            } else {
                 setAccessToken(accessTokenParam);
                 setErrorMessage(null);
                 fetchUser(accessTokenParam);
                 fetchPeople(accessTokenParam);
                 oauthHandled = true;

            }
            sessionStorage.removeItem('oauthState');
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Détection du mode PWA (Standalone)
        const isPwa = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
        setIsStandalone(isPwa);
        // locale: le message d'erreur OAuth au montage est affiché dans la langue courante ;
        // une re-exécution après changement de locale est inoffensive (hash déjà nettoyé).
    }, [locale]);

    useEffect(() => {
        setTimeout(() => setErrorMessage(null), 5000);
    }, [errorMessage]);

    useEffect(() => {
        setTimeout(() => setSuccessMessage(null), 5000);
    }, [successMessage]);

    /**
     * The Person of the logged-in staff member, matched like the backend
     * resolvePerson(): by first and last name, or by email. Returns an empty
     * string when no Person matches.
     */
    const resolveMyPersonId = (): string => {
        if (!currentUser) {
            return '';
        }

        const me = people.find((person: Person) =>
            (currentUser.email && person.email && person.email === currentUser.email)
            || (person.first_name === currentUser.first_name && person.last_name === currentUser.last_name),
        );

        return me ? me.id : '';
    };

    const handleLogout = () => {
        setAccessToken(null);
        setCurrentUser(null);
    };

    const fetchUser = (token: string) => {
        setIsLoading(true);
        axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + '/api/me',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        }).then((response) => {
            setIsLoading(false);
            if (response.data.success) {
                setErrorMessage(null);
                const user = response.data.data;
                console.log("Current user", user);
                setCurrentUser(user);
                setLocale(String(user.locale ?? '').toLowerCase().startsWith('fr') ? 'fr' : 'en');
            } else {
                handleLogout();
            }
        }).catch((error) => {
            setIsLoading(false);
            if (error?.message !== undefined) {
                setErrorMessage(error.message + ". " + t(locale, 'Are you connected to the VPN?'));
            }
            handleLogout();
        });
    };

    const fetchPeople = (token: string) => {
        axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + '/api/people',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        }).then((response) => {
            if (response.data.success) {
                setPeople(response.data.data);
            }
        }).catch((error) => {
            console.error("Error fetching people:", error);
        });
    };

    const handleQrScan = async (data: any) => {
        if (data && data.text) {
            beep();
            setQrResult(data.text);
            setIsLoading(true);

            try {
                setErrorMessage(null);
                const actionableResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/scan/${data.text}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,
                    },
                });

                if (actionableResponse.ok) {
                    setSuccessMessage(t(locale, "Scan succeeded"));
                    const actionableObject = (await actionableResponse.json())?.data;
                    setIsQrValid(true);
                    setActionable(actionableObject);

                    if (actionableObject.property_id) {
                        const propertyResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/properties/${actionableObject.property_id}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'Authorization': `Bearer ${accessToken}`,
                            },
                        });

                        if (propertyResponse.ok) {
                            setProperty((await propertyResponse.json())?.data);
                        }
                    }
                } else {
                    setErrorMessage((await actionableResponse?.json())?.message ?? t(locale, "QR code not allowed."));
                    setQrResult(null);
                }
            } catch (error) {
                console.error("Network error:", error);
                setQrResult(null);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleSubmit = async () => {
        if (qrResult && selectedAction !== 'choose' && actionable) {
            setIsLoading(true);

            let personId = selectedPersonId;

            if (selectedAction === 'Give to someone' && isCreatingPerson) {
                try {
                    const personResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/people`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': `Bearer ${accessToken}`,
                        },
                        body: JSON.stringify(newPerson),
                    });

                    if (personResponse.ok) {
                        const personResult = await personResponse.json();
                        personId = personResult.data.id;
                        // Refetch people to include the new one for future use
                        if (accessToken) fetchPeople(accessToken);
                    } else {
                        const errorData = await personResponse.json();
                        setErrorMessage(t(locale, "Error creating person:") + " " + errorData.message);
                        setIsLoading(false);
                        return;
                    }
                } catch (error) {
                    console.error('Error creating person:', error);
                    setErrorMessage(t(locale, "Error creating person"));
                    setIsLoading(false);
                    return;
                }
            }

            const payload = {
                actionable_id: actionable.id,
                actionable_type: actionable.actionable_type,
                additional_info: additionalInfo,
                type: selectedAction,
                person_id: personId || null,
            };

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/actions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify(payload),
                });

                if (response.ok) {
                    setErrorMessage(null);
                    setSuccessMessage(t(locale, "Action submitted"));

                    setIsSubmitted(true);

                    setTimeout(() => {
                        setQrResult(null);
                        setActionable(null);
                        setSelectedAction('choose');
                        setAdditionalInfo('');
                        setIsSubmitted(false);
                        setIsQrValid(false);
                        setIsScannerStarted(false);
                        setSelectedPersonId('');
                        setIsCreatingPerson(false);
                        setNewPerson({
                            first_name: '',
                            last_name: '',
                            email: '',
                            is_staff_member: false,
                            phone: ''
                        });
                    }, 4000)

                } else {
                    console.error('Submission error');
                    setErrorMessage(t(locale, "Error:") + " " + (await response.json())?.message);
                    setIsSubmitted(false);
                }
            } catch (error) {
                console.error('Network error:', error);
                //alert("Connection error. Please check your network.");
                setErrorMessage(t(locale, "Connection error. Please check your network."));
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrorMessage(t(locale, "Please select an option"));
        }
    };

    const handleGoogleLogin = () => {
        setIsLoading(true);
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        const redirectUri = window.location.origin;
        const scope = 'openid email profile';
        const state = Math.random().toString(36).substring(2);
        sessionStorage.setItem('oauthState', state);

        window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth' +
            `?client_id=${encodeURIComponent(clientId as string)}` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            '&response_type=token' +
            `&scope=${encodeURIComponent(scope)}` +
            `&state=${state}`;
    };

    return (
        <div className="relative min-h-screen flex flex-col items-center justify-center bg-gray-100">
            <img
                src="/celine-concierge_gold.png"
                alt="Céline Concierge"
                className="absolute top-4 left-1/2 transform -translate-x-1/2 h-12 w-auto"
            />
            {errorMessage && (
                <div
                    role="alert"
                    className="fixed top-4 left-1/2 transform -translate-x-1/2 flex items-start gap-3 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded shadow-lg z-50 max-w-md animate-fade-in"
                >
                    <span className="flex-1 pr-2">{errorMessage}</span>
                    <button
                        type="button"
                        onClick={() => setErrorMessage(null)}
                        aria-label={t(locale, 'Close')}
                        className="text-red-700 hover:text-red-900 font-bold leading-none focus:outline-none"
                    >
                        ×
                    </button>
                </div>
            )}
            {successMessage && (
                <div
                    role="alert"
                    className="fixed top-4 left-1/2 transform -translate-x-1/2 flex items-start gap-3 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded shadow-lg z-50 max-w-md animate-fade-in"
                >
                    <span className="flex-1 pr-2">{successMessage}</span>
                    <button
                        type="button"
                        onClick={() => setSuccessMessage(null)}
                        aria-label={t(locale, 'Close')}
                        className="text-green-700 hover:text-green-900 font-bold leading-none focus:outline-none"
                    >
                        ×
                    </button>
                </div>
            )}
            {!currentUser ? (
                <>
                    {!isLoading ? (
                        <div className="flex flex-col items-center">
                            <button className={'mt-4 px-6 py-3 bg-primary text-white font-semibold rounded-lg shadow-md'}
                                    onClick={handleGoogleLogin}>{t(locale, 'Sign in with Google')}
                            </button>
                        </div>
                    ) : (
                        <div className="mt-4 flex items-center justify-center">
                            <div
                                className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                            <span className="ml-2 text-primary font-medium">{t(locale, 'Loading...')}</span>
                        </div>
                    )}
                </>

            ) : (
                <>
                    <div className="absolute top-4 right-4">
                        <h1>{currentUser.first_name}</h1>
                        <button onClick={handleLogout} className="text-gray-500 hover:text-red-500">
                            {t(locale, 'Logout')}
                        </button>
                    </div>

                    {!qrResult && !isScannerStarted && !isSubmitted && (
                        <button
                            onClick={() => setIsScannerStarted(true)}
                            className="mt-4 px-6 py-3 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-75"
                        >
                            {t(locale, 'Start scanning')}
                        </button>
                    )}

                    {!qrResult && isScannerStarted && (
                        <div className="relative bg-white shadow-lg rounded-lg p-8">
                            <QRScanner onScan={handleQrScan} onError={() => console.log('QR scan error')}/>

                            <button
                                onClick={
                                    () => {
                                        setProperty(null);
                                        setIsLoading(false);
                                        setIsSubmitted(false);
                                        setActionable(null);
                                        setQrResult(null);
                                        setIsQrValid(false);
                                        setIsScannerStarted(false);
                                        setSelectedAction('choose');
                                        setAdditionalInfo('');
                                        setSelectedPersonId('');
                                        setIsCreatingPerson(false);
                                        setNewPerson({
                                            first_name: '',
                                            last_name: '',
                                            email: '',
                                            is_staff_member: false,
                                            phone: ''
                                        })
                                    }
                                }
                                className="mt-4 ml-5 px-4 py-2 bg-white text-black font-semibold rounded-lg shadow-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-75"
                            >
                                {t(locale, 'Cancel')}
                            </button>
                        </div>
                    )}

                    {isLoading && (
                        <div className="mt-4 flex items-center justify-center">
                            <div
                                className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                            <span className="ml-2 text-primary font-medium">{t(locale, 'Loading...')}</span>
                        </div>
                    )}

                    {isQrValid && (
                        <div className="bg-white shadow-lg rounded-lg p-8 w-80 mt-6 text-center">
                            <h2 className="truncate text-2xl font-bold text-gray-700 mb-4">{t(locale, 'Identifier:')} {qrResult}</h2>
                            <div className="flex items-center justify-center">
                                {actionable?.first_photo_temporary_url && (
                                    <img src={actionable.first_photo_temporary_url} alt={actionable.id} width={'200'}
                                         className="mt-4 mb-4 "
                                    />
                                )}
                            </div>

                            {property && (
                                <h3 className=" text-sm font-bold text-gray-700 mb-4 content-center">{property.full_address}</h3>
                            )}

                            <h4 className="text-md font-medium text-gray-600 mb-4">{t(locale, 'Choose an action:')}</h4>
                            <select
                                id="action"
                                name="action"
                                value={selectedAction}
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    const value = e.target.value;
                                    setSelectedAction(value);
                                    if (value === 'Give to someone') {
                                        // Default the person to the logged-in staff member (e.g. taking a
                                        // key out of the safe = giving it to yourself); the user can still
                                        // change it. Empty when no Person matches.
                                        setSelectedPersonId(resolveMyPersonId());
                                        setIsCreatingPerson(false);
                                    }
                                }}
                                className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            >
                                <option value="choose">{t(locale, 'Choose')}</option>
                                <option value="Deposit in the safe">{t(locale, 'Deposit in the safe')}</option>
                                <option value="Give to someone">{t(locale, 'Give to someone')}</option>
                                <option value="Give back to customer">{t(locale, 'Give back to customer')}</option>
                            </select>

                            {selectedAction === 'Give to someone' && (
                                <div className="mt-4 text-left">
                                    <label className="block text-sm font-medium text-gray-700">{t(locale, 'Person:')}</label>
                                    <select
                                        value={isCreatingPerson ? 'new' : selectedPersonId}
                                        onChange={(e) => {
                                            if (e.target.value === 'new') {
                                                setIsCreatingPerson(true);
                                                setSelectedPersonId('');
                                            } else {
                                                setIsCreatingPerson(false);
                                                setSelectedPersonId(e.target.value);
                                            }
                                        }}
                                        className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    >
                                        <option value="">{t(locale, 'Select a person')}</option>
                                        {people.map(person => (
                                            <option key={person.id} value={person.id}>
                                                {person.first_name} {person.last_name}
                                            </option>
                                        ))}
                                        <option value="new">{t(locale, '+ Create new person')}</option>
                                    </select>

                                    {isCreatingPerson && (
                                        <div className="mt-2 space-y-2 p-3 border rounded bg-gray-50">
                                            <input
                                                type="text"
                                                placeholder={t(locale, 'First name *')}
                                                value={newPerson.first_name}
                                                onChange={(e) => setNewPerson({
                                                    ...newPerson,
                                                    first_name: e.target.value
                                                })}
                                                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2"
                                            />
                                            <input
                                                type="text"
                                                placeholder={t(locale, 'Last name *')}
                                                value={newPerson.last_name}
                                                onChange={(e) => setNewPerson({
                                                    ...newPerson,
                                                    last_name: e.target.value
                                                })}
                                                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2"
                                            />
                                            <input
                                                type="text"
                                                placeholder={t(locale, 'Phone (ex: +33611223344)')}
                                                value={newPerson.phone}
                                                onChange={(e) => setNewPerson({...newPerson, phone: e.target.value})}
                                                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2"
                                            />
                                            <div className="flex items-center mt-2">
                                                <input
                                                    type="checkbox"
                                                    id="is_staff_member"
                                                    checked={newPerson.is_staff_member}
                                                    onChange={(e) => setNewPerson({
                                                        ...newPerson,
                                                        is_staff_member: e.target.checked
                                                    })}
                                                    className="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
                                                />
                                                <label htmlFor="is_staff_member" className="ml-2 text-sm text-gray-700">{t(locale, 'Staff Member')}</label>
                                            </div>


                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="mt-4 text-left">
                                <label className="block text-sm font-medium text-gray-700">{t(locale, 'Additional Info:')}</label>
                                <textarea
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm border-2 border-black"
                                    rows={3}
                                    value={additionalInfo}
                                    onChange={e => setAdditionalInfo(e.target.value)}
                                />
                            </div>

                            {!isSubmitted && (<>
                                <button
                                    onClick={handleSubmit}
                                    className="mt-4 px-4 py-2 bg-primary text-white font-semibold rounded-lg shadow-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-75"
                                >
                                    {t(locale, 'Submit')}
                                </button>
                                <button onClick={() => {
                                    setProperty(null);
                                    setIsLoading(false);
                                    setIsSubmitted(false);
                                    setActionable(null);
                                    setQrResult(null);
                                    setIsQrValid(false);
                                    setIsScannerStarted(false);
                                    setSelectedAction('choose');
                                    setAdditionalInfo('');
                                    setSelectedPersonId('');
                                    setIsCreatingPerson(false);
                                    setNewPerson({
                                        first_name: '',
                                        last_name: '',
                                        email: '',
                                        is_staff_member: false,
                                        phone: ''
                                    });
                                }}
                                        className="mt-4 ml-5 px-4 py-2 bg-white text-black font-semibold rounded-lg shadow-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-75"
                                >
                                    {t(locale, 'Cancel')}
                                </button>
                            </>)}
                            {isSubmitted && (
                                 <div className={'flex justify-center w-full'}>
                                     <video autoPlay={true} playsInline={true} width={'50%'} src={"/greencheck.mp4"}>
                                    </video>
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
            <footer className="fixed bottom-2 left-0 right-0 text-center text-xs text-gray-500">
                {process.env.REACT_APP_APP_VERSION}
            </footer>
            {showBanner && !isStandalone && (
                <div
                    className="fixed bottom-10 left-0 right-0 bg-primary text-white p-3 text-center shadow-lg z-50 sm:hidden">
                    <p className="text-xs font-bold">{t(locale, 'Add to Home Screen (Safari only) 🚀')}</p>
                    <p className="text-[10px] opacity-90">{t(locale, 'Tap the Share button, then "Add to Home Screen". (Safari only)')}</p>
                    <button onClick={() => setShowBanner(false)} className={'p-1 border-2 mt-2'}>{t(locale, 'Close')}</button>
                </div>
            )}
        </div>
    );
}

export default App;
